// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2irNu","label":"Labeled_label__2jo9y","divider":"Labeled_divider__2qtHb"};